import type { FeatureFlagName } from '@frameio/feature-flags';

/**
 * Feature-flag keys for non-onboarding tooltip features.
 * Onboarding feature is enabled via first-login (tooltipsEnabled), not a flag.
 * Add a new entry here and sync it in useSyncTooltipFeatureFlags when adding a feature.
 * Values must exist in the feature-flags package's FEATURE_FLAG_NAMES.
 * Features are specified as arrays (even singular).
 */
export const TOOLTIP_FEATURE_FLAGS = {
  aiAssistant: ['v4.archon_assistant_queries'],
  mountableStorage: ['v4.mountable_storage'],
  shareLists: ['v4.share_lists'],
  labs: ['v4.labs'],
  uploadLinks: ['v4.upload_links'],
  minorVersions: ['api.mounted_storage_minor_versions'],
} as const satisfies Record<string, FeatureFlagName[]>;
